import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "KanitBold";
        src: url("/fonts/Kanit-Bold.ttf");
        font-style: normal;
    }

    @font-face {
        font-family: "KanitLight";
        src: url("/fonts/Kanit-Light.ttf");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'KanitLight';
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: #60076c;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'KanitBold';
        color:#000;
        font-size: 54px;
        line-height: 1.18;
        z-index:-1

        @media only screen and (max-width: 890px) {
          font-size: 38px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 38px;
        }
    }

    p {
        color: #fff;
        font-size: 32px;        
        line-height: 1.41;
        @media only screen and (max-width: 890px) {
            font-size: 24px;
          }
        
          @media only screen and (max-width: 414px) {
            font-size: 24px;
          }
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #18d6d3;
        font-family:KanitBold;

        :hover {
            color: #18d6d3;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        background-color: #000;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
